"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionArray = exports.SNACKBAR_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var helper_1 = require("../../utils/helper");
var keepDom_1 = require("../../utils/keepDom");
var Spin_1 = tslib_1.__importDefault(require("../Loading/Spin"));
var theme_1 = require("../../utils/theme");
var show_1 = require("../../utils/show");
var preventScrollPenetrate_1 = require("../../utils/preventScrollPenetrate");
var Button_1 = tslib_1.__importDefault(require("../Button"));
exports.SNACKBAR_TRANSITION_DURATION = 200;
function isActionArray(action) {
    return Array.isArray(action) && action.length > 0 && action[0].text;
}
exports.isActionArray = isActionArray;
var Snackbar = (function (_super) {
    tslib_1.__extends(Snackbar, _super);
    function Snackbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prevTouchScreenY = 0;
        _this.handleTouchStart = function (e) {
            var touch = _this.getValidTouch(e);
            if (!touch) {
                return;
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.handleTouchMove = function (e) {
            var touch = _this.getValidTouch(e);
            if (!touch) {
                return;
            }
            if (_this.prevTouchScreenY - touch.screenY > 8) {
                return _this.context();
            }
            _this.prevTouchScreenY = touch.screenY;
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, message = _b.message, placement = _b.placement, visible = _b.visible, type = _b.type, zIndex = _b.zIndex, spinType = _b.spinType;
            var classes = classNames(prefixCls, className, prefixCls + "-" + placement, prefixCls + "-" + type, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            var messageClasses = classNames(prefixCls + "-message");
            if (!keepDom_1.decideKeepDom.call(_this, exports.SNACKBAR_TRANSITION_DURATION, visible)) {
                return null;
            }
            return react_dom_1.default.createPortal(h(preventScrollPenetrate_1.PreventScrollPenetrateContainer, { className: classes, style: tslib_1.__assign({ zIndex: zIndex }, style), onTouchStart: _this.handleTouchStart, onTouchMove: _this.handleTouchMove },
                type === 'loading' ?
                    h(Spin_1.default, { type: spinType, className: classNames(prefixCls + "-loading-indicator"), circleClassName: classNames(prefixCls + "-loading-indicator-circle") }) : null,
                h("span", { className: messageClasses }, children || message),
                _this.renderAction(classNames)), document.body);
        };
        return _this;
    }
    Snackbar.prototype.getValidTouch = function (e) {
        var _a = this.props, autoClose = _a.autoClose, visible = _a.visible;
        if (!visible || !autoClose) {
            return null;
        }
        return e.touches.item(0);
    };
    Snackbar.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Snackbar.prototype.renderAction = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, action = _a.action, onClickAction = _a.onClickAction;
        if (!action) {
            return null;
        }
        if (isActionArray(action)) {
            return (h("span", { className: classNames(prefixCls + "-actions") }, action.map(function (a, index) {
                return h(Button_1.default, { key: index, className: classNames(prefixCls + "-action"), onClick: a.onClick }, a.text);
            })));
        }
        return (h(Button_1.default, { className: classNames(prefixCls + "-action"), onClick: onClickAction }, action));
    };
    Snackbar.contextType = show_1.ShowCloseContext;
    return Snackbar;
}(React.Component));
exports.default = Snackbar;
Snackbar.defaultProps = {
    prefixCls: 'dui-m-snackbar',
    placement: 'top',
    onClickAction: helper_1.emptyFn,
    type: 'info',
    spinType: 'primary',
};
Snackbar.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    action: PropTypes.any,
    message: PropTypes.node,
    placement: PropTypes.oneOf(['top', 'bottom']),
    visible: PropTypes.bool,
    duration: PropTypes.number,
    onClickAction: PropTypes.func,
    type: PropTypes.oneOf(['info', 'success', 'error', 'loading']),
    zIndex: PropTypes.number,
    spinType: PropTypes.oneOf(['light', 'dark', 'primary']),
};
